import { ListingTopMainLink } from '../Top/components/ListingTopMainLink';
import './Breadcrumbs.scss';

interface Breadcrumb {
    name: string;
    id: string;
    type: string;
    url: string;
    config_properties: string;
}

interface BreadcrumbsProps {
    items: Breadcrumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
    return (
        <nav aria-label="breadcrumbs">
            <ul className="listing-breadcrumbs">
                {
                    items.map(breadcrumbItem => (
                        <li
                            key={breadcrumbItem.name}
                            className="listing-breadcrumbs__item mr-8"
                        >
                            { /* @ts-ignore */ }
                            <ListingTopMainLink link={breadcrumbItem} />
                        </li>
                    ))
                }
            </ul>
        </nav>
    );
}
